export default __webpack_public_path__ + "static/media/shutdown.17b27a77.png";